import { useCallback, useMemo, useState } from 'react';
import useSearchParamsConfig from './useSearchParamsConfig';

export default function useContactFilters(defaultSearchParams) {
  const filters = useMemo(
    () => ({
      contactOwners: [],
    }),
    [],
  );

  const [defaultParams] = useState(defaultSearchParams);

  const searchParamsConfig = useSearchParamsConfig();

  const contactSearchParamsConfig = useMemo(
    () => ({
      contactOwners: searchParamsConfig.contactOwners,
      ...defaultParams,
    }),
    [searchParamsConfig, defaultParams],
  );

  const mapUrlSearchParams = useCallback((filters) => {
    return {
      contactOwnerId: filters.contactOwners?.map((owner) => owner.id),
    };
  }, []);

  return useMemo(
    () => ({ filters, searchParamsConfig: contactSearchParamsConfig, mapUrlSearchParams }),
    [filters, contactSearchParamsConfig, mapUrlSearchParams],
  );
}
